// extracted by mini-css-extract-plugin
module.exports = {"lang__icon":"index_lang__icon__p6_9H"};